"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeUlrParamsToObject = exports.encodeObjectToUlrParams = void 0;
function encodeObjectToUlrParams(obj) {
    if (!obj || typeof obj !== "object" || Object.keys(obj).length === 0) {
        return "";
    }
    return ("?" +
        Object.keys(obj)
            .map(function (key) { return "".concat(key, "=").concat(encodeURIComponent(obj[key])); })
            .join("&"));
}
exports.encodeObjectToUlrParams = encodeObjectToUlrParams;
function decodeUlrParamsToObject(params) {
    return ((params === null || params === void 0 ? void 0 : params.replace(/^\?/, "").split("&").reduce(function (acc, chunk) {
        var _a;
        if (!chunk) {
            return acc;
        }
        var _b = chunk.split("="), key = _b[0], value = _b[1];
        return __assign(__assign({}, acc), (_a = {}, _a[key] = decodeURIComponent(value), _a));
    }, {})) || {});
}
exports.decodeUlrParamsToObject = decodeUlrParamsToObject;
